import { handleResponse, Headers } from '../_helpers';

export const MapService = {
  getChronicleMaps,
  getWorldMaps,
  getMap,
  createMap,
  updateMap,
  deleteMap,
};

function getChronicleMaps(chronicleID) {
  const request = {
    method: 'GET',
    headers: Headers.set(),
  };

  return fetch(
    `${process.env.API_URL}/api/v1/map/chronicle/${chronicleID}`,
    request
  )
    .then(handleResponse)
    .then((maps) => {
      return maps;
    });
}

function getWorldMaps(worldID) {
  const request = {
    method: 'GET',
    headers: Headers.set(),
  };

  return fetch(`${process.env.API_URL}/api/v1/map/world/${worldID}`, request)
    .then(handleResponse)
    .then((maps) => {
      return maps;
    });
}

function getMap(mapID) {
  const request = {
    method: 'GET',
    headers: Headers.set(),
  };

  return fetch(`${process.env.API_URL}/api/v1/map/${mapID}`, request)
    .then(handleResponse)
    .then((map) => {
      return map;
    });
}

function createMap(mapData) {
  const request = {
    method: 'POST',
    headers: Headers.set(),
    body: JSON.stringify(mapData),
  };

  return fetch(`${process.env.API_URL}/api/v1/map/`, request)
    .then(handleResponse)
    .then((map) => {
      return map;
    });
}

function updateMap(mapID, mapData) {
  const request = {
    method: 'PUT',
    headers: Headers.set(),
    body: JSON.stringify(mapData),
  };

  return fetch(`${process.env.API_URL}/api/v1/map/${mapID}`, request)
    .then(handleResponse)
    .then((map) => {
      return map;
    });
}

function deleteMap(mapID) {
  const request = {
    method: 'DELETE',
    headers: Headers.set(),
  };

  return fetch(`${process.env.API_URL}/api/v1/map/${mapID}`, request)
    .then(handleResponse)
    .then((data) => {
      console.log('MAP DELETE SERVICE', data);
      return data;
    });
}
